import {
  FETCH_ALL_FIELD_REPORTS,
  FETCH_MARKET_FIELD_REPORTS,
  IS_LOADING,
} from '../actions/fieldReports';
import { FieldReportStatuses } from '../lib/utils';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_ALL_FIELD_REPORTS:
      return {
        ...state,
        fieldReports: action.payload,
      };
    case FETCH_MARKET_FIELD_REPORTS:
      return {
        ...state,
        marketFieldReports: action.payload,
        newFieldReports: action.payload.filter(
          (report) => report.status === FieldReportStatuses.NEW,
        ),
      };
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
}
